import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Card, CardBody, Progress } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCoins } from '@fortawesome/free-solid-svg-icons'
import Flex from '../../common/Flex'
import { clampPercent, formatNumber, formatUsd } from '../rewardsUtils'

// Mismo flujo que el botón "Pagar cuentas" de Mis cuentas por pagar.
const PAY_ROUTE = '/dashboard/my/finance/topays'

const CoinsCard = ({ summary }) => {
  const {
    hc_balance: balance,
    usd_available: usd,
    hc_lifetime_earned: earned,
    hc_lifetime_spent: spent,
    redemption
  } = summary
  const minHc = Number(redemption?.min_hc) || 0
  const canRedeem = !!redemption?.can_redeem
  const missingHc = Math.max(minHc - (Number(balance) || 0), 0)

  return (
    <Card className="h-100">
      <CardBody>
        <Flex align="center" className="mb-3">
          <div
            className="d-flex flex-center rounded-circle mr-3 flex-shrink-0 bg-soft-warning text-warning"
            style={{ width: '3.5rem', height: '3.5rem' }}
          >
            <FontAwesomeIcon icon={faCoins} className="fs-3" />
          </div>
          <div className="flex-grow-1">
            <h6 className="text-600 mb-1">Homelan Coins</h6>
            <h3 className="mb-0">
              {formatNumber(balance)} <span className="fs-0 text-600">HC</span>
            </h3>
          </div>
          {/* El equivalente lo calcula el backend con su tasa de canje vigente. */}
          <div className="text-right ml-2">
            <h6 className="text-600 mb-1 fs--1">Equivalen a</h6>
            <span className="font-weight-semi-bold text-success">{formatUsd(usd)}</span>
          </div>
        </Flex>

        {!canRedeem && minHc > 0 && (
          <>
            <Flex justify="between" align="end" className="mb-1">
              <span className="fs--1 text-600">Camino a tu primer canje</span>
              <span className="fs--1 font-weight-semi-bold">
                {formatNumber(Math.min(Number(balance) || 0, minHc))} / {formatNumber(minHc)} HC
              </span>
            </Flex>
            <Progress
              value={clampPercent(((Number(balance) || 0) / minHc) * 100)}
              color="warning"
              className="rounded-capsule mb-2"
              style={{ height: '0.625rem' }}
              barAriaValueText="Avance hacia el mínimo de canje"
            />
            <p className="fs--1 mb-0 text-600">
              Te faltan <b className="text-900">{formatNumber(missingHc)} HC</b> para poder canjearlos al pagar tu
              cuota.
            </p>
          </>
        )}

        {canRedeem && (
          <p className="fs--1 mb-2 text-600">
            Ya puedes usar tus Coins para pagar tu cuota: cubren hasta <b className="text-900">{formatUsd(usd)}</b>.{' '}
            <Link to={PAY_ROUTE} className="font-weight-semi-bold text-nowrap">
              Ir a pagar
            </Link>
          </p>
        )}

        {(Number(earned) > 0 || Number(spent) > 0) && (
          <p className="fs--2 mb-0 text-500">
            Has ganado {formatNumber(earned)} HC en total y canjeado {formatNumber(spent)} HC.
          </p>
        )}
      </CardBody>
    </Card>
  )
}

CoinsCard.propTypes = { summary: PropTypes.object.isRequired }

export default CoinsCard
